/**
 * A node's 2D world position over the live scene tree, so a Camera2D inside an
 * instance composes against the instance transform. The Cameras panel frames the
 * 2D stage with it, without touching live THREE objects.
 */
import { liveNodeChain } from './liveSceneTree';
import { NO_PATCHES } from './nodePatch';
import { parentLookup } from '../linter/parentType.js';
import { resolveGlobalTransform2D } from '../nodes/canvasitem/shared/globalTransform2D.js';
/**
 * The parent lookup over a live chain, root first. A collapsed instance carries its
 * sub-scene root's type, so only an instance whose scene is not cached stays opaque.
 */
function chainParentOf(chain) {
    const parents = new Map(chain.slice(1).map((child, i) => [child, chain[i]]));
    return (child) => parentLookup(parents.get(child));
}
/** The pose each node of `chain`, which ends at the live path `path`, takes from the patches in `placed`. */
function posesAlong(chain, path, placed) {
    const names = path.split('/');
    const poses = new Map();
    chain.forEach((node, index) => {
        const patch = placed.get(names.slice(0, index + 1).join('/'));
        if (patch)
            poses.set(node, patch);
    });
    return poses;
}
/**
 * The node's world position in Godot pixel space, through Godot's canvas parent
 * chain. Null for an unknown path, and for a chain this cannot decode: an opaque
 * ancestor, or a Control between the node and the top of its chain. `placed` holds the poses the
 * live scene passes bound.
 */
export function node2dWorldPosition(roots, ctx, path, placed = NO_PATCHES) {
    const chain = liveNodeChain(path, roots, ctx);
    if (!chain)
        return null;
    const verdict = resolveGlobalTransform2D(chain[chain.length - 1], chainParentOf(chain), posesAlong(chain, path, placed));
    if (verdict.kind === 'unknowable')
        return null;
    return { x: verdict.transform.tx, y: verdict.transform.ty };
}
//# sourceMappingURL=node2dWorldTransform.js.map